import { useCallback, useState } from 'react';
import { knowledgeSourceService } from '../services';
import { KnowledgeSource } from '../types/entities';

export const useKnowledgeSources = (organizationId?: number) => {
  const [knowledgeSources, setKnowledgeSources] = useState<KnowledgeSource[]>(
    []
  );
  const [isLoadingKnowledge, setIsLoadingKnowledge] = useState(false);

  const loadKnowledgeSources = useCallback(async () => {
    if (!organizationId) return;

    try {
      setIsLoadingKnowledge(true);
      const allSources: KnowledgeSource[] = [];
      let page = 1;
      let totalPages = 1;

      do {
        const response = await knowledgeSourceService.getAll({
          organization_id: organizationId,
          page,
          page_size: 50,
        });

        allSources.push(...(response.items || []));
        totalPages = Math.max(1, response.total_pages || 1);
        page += 1;
      } while (page <= totalPages);

      setKnowledgeSources(allSources);
    } catch (error) {
      console.error('Error loading knowledge sources:', error);
      throw error;
    } finally {
      setIsLoadingKnowledge(false);
    }
  }, [organizationId]);

  const toggleKnowledgeSource = useCallback(
    (
      source: KnowledgeSource,
      selectedSources: KnowledgeSource[],
      onUpdate: (sources: KnowledgeSource[]) => void
    ) => {
      const isSelected = selectedSources.some(s => s.id === source.id);
      const newSources = isSelected
        ? selectedSources.filter(s => s.id !== source.id)
        : [...selectedSources, source];

      onUpdate(newSources);
    },
    []
  );

  const removeKnowledgeSource = useCallback(
    (
      sourceId: number,
      selectedSources: KnowledgeSource[],
      onUpdate: (sources: KnowledgeSource[]) => void
    ) => {
      const newSources = selectedSources.filter(s => s.id !== sourceId);
      onUpdate(newSources);
    },
    []
  );

  return {
    knowledgeSources,
    setKnowledgeSources,
    isLoadingKnowledge,
    loadKnowledgeSources,
    toggleKnowledgeSource,
    removeKnowledgeSource,
  };
};
